import React, { useCallback, useContext } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';

import PipelineImage from '../../../assets/pipeline.png';
import { DOCS_GETTING_STARTED_URL } from '../const';

// eslint-disable-next-line import/no-unresolved
import OnboardingContext from './OnboardingContext';
import {
  PipelineCardContent,
  PipelineCardWrapper,
  StyledPipeline,
} from './styled';

const PipelineCard = () => {
  const { analyticsSource } = useContext(OnboardingContext);
  const { createAnalyticsEvent } = useAnalyticsEvents();

  const viewDocumentation = useCallback(() => {
    createAnalyticsEvent({
      action: 'clicked',
      actionSubject: 'button',
      actionSubjectId: 'pipelinesHowToGetStarted',
      source: analyticsSource,
    }).fire();
  }, [analyticsSource, createAnalyticsEvent]);

  return (
    <PipelineCardWrapper>
      <StyledPipeline src={PipelineImage} alt="Pipeline" />
      <PipelineCardContent>
        <h1>Easy setup and support for all platforms</h1>
        <h3>
          Set up CI/CD in 2 easy steps with language-specific
          <br />
          templates. No servers to manage, repositories to
          <br /> synchronize, or user management to configure.
          <br />
        </h3>
        <h3>
          Read
          <Button
            appearance="link"
            target="_blank"
            href={DOCS_GETTING_STARTED_URL}
            onClick={viewDocumentation}
          >
            how to get started
          </Button>
          with Bitbucket Pipelines.
        </h3>
      </PipelineCardContent>
    </PipelineCardWrapper>
  );
};

export default React.memo(PipelineCard);
